import {
  AppServiceWebapp,
  ResolvedDependency,
} from '@wix/ambassador-app-service-webapp/http';

const appService = '/_api/app-service-webapp/';

const AppDependencyService = AppServiceWebapp(appService).Dependencies();

const getAppDependencies = async (
  appId: string,
  appVersion?: string,
): Promise<ResolvedDependency[]> => {
  const dependenciesByVersion =
    await AppDependencyService().resolveDependenciesByVersion({
      appIdsToVersions: [{ appId, version: appVersion ?? 'latest' }],
    });

  const dependencies =
    dependenciesByVersion?.appIdToResolvedDependencies?.[appId]?.dependencies;

  return dependencies || [];
};

export { getAppDependencies };
